import { ClientComponentLogger } from '../../client-component-logger';

export class TrackingDataExtractor {
    constructor(private logger: ClientComponentLogger) {}

    public extractTrackingData(targetElement: Element, dataAttributeName: string) {
        const trackingData = targetElement.getAttribute(dataAttributeName);
        if (trackingData) {
            try {
                return JSON.parse(trackingData);
            } catch (e: unknown) {
                this.logger.logError({ message: `cant parse tracking data: ${trackingData}` });
            }
        }
        return null;
    }
}
